module.exports = __webpack_public_path__ + "img/engagement_7.36455cf3.jpg";